import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=4b6defde&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b6defde')) {
      api.createRecord('4b6defde', component.options)
    } else {
      api.reload('4b6defde', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=4b6defde&", function () {
      api.rerender('4b6defde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/Modal.vue"
export default component.exports